// extracted by mini-css-extract-plugin
module.exports = {"subscription-bl":"subscribe-buttons_subscription-bl__Eb97q","sub-btn":"subscribe-buttons_sub-btn__ZMMcW"};